module.exports = __webpack_public_path__ + "static/media/film.cc9a7876.svg";